var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhotoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 48C0 21.4903 21.4903 0 48 0C74.5097 0 96 21.4903 96 48C96 74.5097 74.5097 96 48 96C21.4903 96 0 74.5097 0 48Z",
    fill: "#F3F4F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3332 37.3333H44.6665L41.3332 41.3333H37.3332C36.6259 41.3333 35.9476 41.6143 35.4476 42.1144C34.9475 42.6145 34.6665 43.2928 34.6665 44V56C34.6665 56.7073 34.9475 57.3855 35.4476 57.8856C35.9476 58.3857 36.6259 58.6667 37.3332 58.6667H58.6665C59.3737 58.6667 60.052 58.3857 60.5521 57.8856C61.0522 57.3855 61.3332 56.7073 61.3332 56V44C61.3332 43.2928 61.0522 42.6145 60.5521 42.1144C60.052 41.6143 59.3737 41.3333 58.6665 41.3333H54.6665L51.3332 37.3333Z",
    stroke: "#99A1AF",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48 53.3333C50.2091 53.3333 52 51.5425 52 49.3333C52 47.1242 50.2091 45.3333 48 45.3333C45.7909 45.3333 44 47.1242 44 49.3333C44 51.5425 45.7909 53.3333 48 53.3333Z",
    stroke: "#99A1AF",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoIcon);
export default __webpack_public_path__ + "static/media/photo-icon.bef15e2f44c8a43fa846c2efc65fb796.svg";
export { ForwardRef as ReactComponent };